import React from "react"
import trans from "trans"
import { ReactSortable } from "react-sortablejs"

import {
    Icon,
    Select,
    Theme,
    Message,
    css,
    Button,
    Grid,
    GridCell,
    Badge,
    FieldLabel,
    Toggler,
} from "@bdfx/mergado-ui-kit"

import { ToastIconSize } from "template-list/containers/template-list";
import { AllPathTypes, AllPathTypesAndMeanings, PathPoint, PathType } from 'shape-entities/types/PathShape';
import * as NumericInputField from 'react-numeric-input';
import { Slider } from "@mui/material";
import { recalcShapeSizeAndPointsPositions } from "./helpers";

const InputForm = ({ form, formName, field, label, point, idx, change, shape, type = 'inputfield',value= undefined, options = undefined, min = undefined, max = undefined, step = undefined }) => {
    const changeValue = (val) => {
        let updatedPoints = [...shape.points]
        updatedPoints[idx][field] = val
        const updatedShape = recalcShapeSizeAndPointsPositions(form, { ...shape, points: updatedPoints }, `curve${shape.index}`)
        change(formName, `shapes.${shape.index}`, { ...updatedShape })
    }

    const ff = type === 'slider' ?
        <Slider
            size={"small"}
            value={typeof value !== 'undefined' ? value : point[field]}
            onChange={(event, val) => changeValue(val)}
            defaultValue={.5}
            min={min}
            max={max}
            step={step}
            valueLabelDisplay="auto"
        /> :
        type === 'switcher' ?
            <Toggler
                value={point[field]}
                onChange={(val) => changeValue( val ? 1 : 0)}
            /> :
            type === 'select' ?
                <Select
                    options={options}
                    value={point[field]}
                    multiple={false}
                    closeOnChange={true}
                    onChange={(val) => changeValue(val)}
                />
                :
            <NumericInputField
                placeholder={field}
                value={point[field]}
                onChange={(val) => changeValue(val)}
                snap
            />

    return <React.Fragment>
        {label}
        {ff}
    </React.Fragment>
}

const PathForm = ({ form, formName, change, shape }) => {
    if (!shape.points || shape.points.length < 1) {
        return <Message type="info" closeable={false} icon={<Icon type={'info-circle'} color={Theme.steelblue} size={ToastIconSize} />}>
            {trans("info_no_points")}
        </Message>
    }

    const list = shape.points.map((point, i) => { return { id: i } })

    return (
        <StyledDiv className={'bezier-form'}>
            {/* TODO: */}
            <StyledPredefinedShapesGrid>
                {/* <GridCell>
                    <img
                        title="heart"
                        className="clickable shape-image"
                        src={`${URL.publicPath}img/shapes/heart.svg`}
                        onClick={(val) => {
                            let updatedPoints: PathPoint[] = []
                            updatedPoints.push({ t: 'M', x: -100, y: 100})
                            updatedPoints.push({ t: 'S', x: -100, y: -100, cx: -65, cy: 75})
                            updatedPoints.push({ t: 'A', x: 100, y: -100, cx: 70, cy: 70, cx2: null, cy2: null, isLargeArc: 0, isSweep: 1, xRotDegrees: -45 })
                            updatedPoints.push({ t: 'A', x: 100, y: 100, cx: 70, cy: 70, cx2: null, cy2: null, isLargeArc: 0, isSweep: 1, xRotDegrees: 45 })
                            updatedPoints.push({ t: 'S', x: -100, y: 100, cx: -35, cy: 40})

                            const updatedShape: PathShape = {
                                ...shape,
                                //angle: -45,
                                points: updatedPoints,
                                color: '#cc0000',
                                stroke_color: '#cc0000',
                                stroke_width: 2,
                            }

                            change(formName, `shapes.${shape.index}`, updatedShape)
                        }}
                    />
                </GridCell> */}
            </StyledPredefinedShapesGrid>

            <div style={{ margin: '10px 0', maxHeight: '200px', overflow: 'auto' }}>
                <FieldLabel>{trans('bezier')}: {trans('points_coordinates')}</FieldLabel>

                <ReactSortable
                    handle=".drag-handle"
                    list={list}
                    tag={'div'}
                    setList={(list) => {
                        const newOrder = list.map((item) => item.id)
                        const order = shape.points.map((point, key) => key)
                        if (newOrder.join(',') !== order.join(',')) {
                            let updatedPoints = []
                            newOrder.forEach(idx => {
                                updatedPoints.push(shape.points[idx])
                            })
                            change(formName, `shapes.${shape.index}.points`, updatedPoints)
                        }
                    }}>
                    {shape.points.map((point: PathPoint, key: number) => {
                        const pointType = !point?.cx2 && !point?.cy2 && !point?.t ? 'S' : (point?.t ?? 'C')
                        return <StyledPointsGrid key={`PathPoint${key}`}>
                            <GridCell className="drag-handle nowrap padding bb">
                                <Icon type={'arrows-v'} color={Theme.blue} text={`${key}.`} />
                            </GridCell>

                            <GridCell className="bb">
                                <InputForm
                                    form={form}
                                    formName={formName}
                                    field={'t'}
                                    label={''}
                                    point={point}
                                    idx={key}
                                    change={change}
                                    shape={shape}
                                    options={AllPathTypes.map((t: PathType) => {
                                        return {
                                            label: `${t} (${AllPathTypesAndMeanings[t] ?? ''})`,
                                            value: t,
                                        }
                                    })}
                                    type={'select'}
                                    value={pointType}
                                />
                            </GridCell>

                            <GridCell className="bb">
                                <InputForm
                                    form={form}
                                    formName={formName}
                                    field={'x'}
                                    label={'x'}
                                    point={point}
                                    idx={key}
                                    change={change}
                                    shape={shape}
                                />
                            </GridCell>

                            <GridCell className="bb">
                                <InputForm
                                    form={form}
                                    formName={formName}
                                    field={'y'}
                                    label={'y'}
                                    point={point}
                                    idx={key}
                                    change={change}
                                    shape={shape}
                                />
                            </GridCell>

                            {['A', 'C', 'S'].includes(pointType) &&
                                <React.Fragment>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'cx'}
                                            label={<span>{pointType === 'A' ? 'r' : 'c'}<sub>x</sub></span>}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                        />
                                    </GridCell>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'cy'}
                                            label={<span>{pointType === 'A' ? 'r' : 'c'}<sub>y</sub></span>}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                        />
                                    </GridCell>
                                </React.Fragment>
                            }

                            {pointType === 'A' &&   //A rx ry x-axis-rotation large-arc-flag sweep-flag x y
                                <React.Fragment>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'xRotDegrees'}
                                            label={'x-rot'}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                            type={'slider'}
                                            min={0}
                                            max={360}
                                            step={1}
                                        />
                                    </GridCell>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'isLargeArc'}
                                            label={'large-arc'}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                            type={'switcher'}
                                        />
                                    </GridCell>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'isSweep'}
                                            label={'sweep'}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                            type={'switcher'}
                                        />
                                    </GridCell>
                                </React.Fragment>
                            }

                            {pointType === 'C' &&
                                <React.Fragment>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'cx2'}
                                            label={<span>c<sub>x2</sub></span>}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                        />
                                    </GridCell>
                                    <GridCell className="bb">
                                        <InputForm
                                            form={form}
                                            formName={formName}
                                            field={'cy2'}
                                            label={<span>c<sub>y2</sub></span>}
                                            point={point}
                                            idx={key}
                                            change={change}
                                            shape={shape}
                                        />
                                    </GridCell>
                                </React.Fragment>
                            }

                            <GridCell className="bb">
                                <Grid cols={'repeat(2, 1fr)'} style={{height: '32px'}}>
                                <Badge
                                    title={trans('delete')}
                                    style={{ cursor: 'pointer' }}
                                    small={true}
                                    onClick={() => {
                                        let updatedPoints = [...shape.points]
                                        updatedPoints.splice(key, 1)
                                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                                    }}>
                                    <Icon type={'close'} color={Theme.red} size={16} />
                                </Badge>
                                <Badge
                                    title={trans('add_point')}
                                    style={{ cursor: 'pointer' }}
                                    small={true}
                                    onClick={() => {
                                        let updatedPoints = [...shape.points]
                                        const lastPoint = shape.points.length > 1 && shape.points[shape.points.length - 1] ? shape.points[shape.points.length - 1] : point
                                        const prevPoint = shape.points.length > 1 && shape.points[(key - 1)] ? shape.points[(key - 1) % (shape.points.length - 1)] : lastPoint
                                        const newPoint: PathPoint = {
                                            x: Math.round((point.x + prevPoint.x) / 2),
                                            y: Math.round((point.y + prevPoint.y) / 2),
                                            cx: Math.round((point.x + prevPoint.x) / 2),
                                            cy: Math.round((point.y + prevPoint.y) / 2),
                                        }
                                        updatedPoints.splice(key, 0, newPoint)
                                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                                    }}>
                                    <Icon type={'plus'} color={Theme.blue} size={16} />
                                    </Badge>
                                    </Grid>
                            </GridCell>
                        </StyledPointsGrid>
                    })}
                </ReactSortable>
                </div>

        </StyledDiv>
    )
}

const StyledPredefinedShapesGrid = css(Grid)({
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    gridGap: '5px',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' img.shape-image': {
        maxWidth: '80px',
        maxHeight: '60px',
    }
})

const StyledPointsGrid = css(Grid)({
    gridTemplateColumns: '40px 80px repeat(7, 1fr)',
    ' .muk-gridcell': {
        textAlign: 'center',
    },
    ' .muk-gridcell.bb': {
        alignSelf: 'end',
    },
    ' .muk-gridcell.cc': {
        alignSelf: 'center',
    },
    ' .drag-handle': {
        fontSize: '10px',
    },
})

const StyledDiv = css('div')({
    ' .drag-handle': {
        cursor: 'move',
    },
    ' > table': {
        width: '100%',
    },
    ' .padding': {
        padding: '10px',
    },
    ' .center': {
        textAlign: 'center',
    },
    ' span.react-numeric-input input': {
        minHeight: '38px',
        maxWidth: '65px',
        fontSize: '12px !important',
        textAlign: 'right',
        paddingRight: '5px',
    },
    ' input.m-textinput-select': {
        minHeight: '38px',
        maxWidth: '120px',
        fontSize: '12px !important',
        textAlign: 'left',
    },
    ' td': {
        fontSize: '12px !important',
    },
    ' td button.m-button:last-child': {
        marginRight: '10px',
    },
    ' td li': {
        whiteSpace: 'nowrap',
    }
})

export default PathForm